import { getLocalTimeZone, today, type CalendarDate } from '@internationalized/date';

export type PyAnalystDatePresetId = '1d' | '2d' | '3d' | '1w' | '15d' | '1mo' | 'custom';

export const PYANALYST_DEFAULT_PRESET: PyAnalystDatePresetId = '1w';

export const PYANALYST_DATE_PRESET_OPTIONS: ReadonlyArray<{
  id: PyAnalystDatePresetId;
  shortLabel: string;
  label: string;
}> = [
  { id: '1d', shortLabel: '1d', label: 'Past 1 Day' },
  { id: '2d', shortLabel: '2d', label: 'Past 2 Days' },
  { id: '3d', shortLabel: '3d', label: 'Past 3 Days' },
  { id: '1w', shortLabel: '1w', label: 'Past 7 Days' },
  { id: '15d', shortLabel: '15d', label: 'Past 15 Days' },
  { id: '1mo', shortLabel: '1mo', label: 'Past 1 Month' },
  { id: 'custom', shortLabel: '📅', label: 'Select from calendar...' },
];

const PRESET_DAY_OFFSETS: Record<Exclude<PyAnalystDatePresetId, 'custom' | '1mo'>, number> = {
  '1d': 1,
  '2d': 2,
  '3d': 3,
  '1w': 7,
  '15d': 15,
};

export function getPyAnalystPresetOption(preset: PyAnalystDatePresetId) {
  return PYANALYST_DATE_PRESET_OPTIONS.find((option) => option.id === preset);
}

/** Display date for Pyanalyst UI (matches analyst list en-GB style). */
export function formatPyAnalystDisplayDate(date: CalendarDate): string {
  const [year, month, day] = date.toString().split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function getPyAnalystPresetDateRange(
  preset: Exclude<PyAnalystDatePresetId, 'custom'>
): { dateFrom: CalendarDate; dateTo: CalendarDate } {
  const dateTo = today(getLocalTimeZone());
  if (preset === '1mo') {
    return { dateFrom: dateTo.subtract({ months: 1 }), dateTo };
  }
  const days = PRESET_DAY_OFFSETS[preset] ?? 7;
  return { dateFrom: dateTo.subtract({ days }), dateTo };
}
